export default __webpack_public_path__ + "static/media/clock_transparent.382c1853.svg";